import { DialogComponent } from "./dialog.component";
export default DialogComponent;
